import { normalizePhoneNumber } from '../functions/formatPhoneNumber.jsx'
import { fetchAuthSession } from 'aws-amplify/auth';

// // Configure the URL for the api query.
const endpointUrl = 'https://ugczaq3r89.execute-api.us-east-1.amazonaws.com/dev/admincreateuser';

export const resendInvite = async (props) => {
  const {
    emailAddress,
    phoneNumber,
  } = props

  const normalizedPhoneNumber = (phoneNumber?.length>0) ? normalizePhoneNumber(phoneNumber) : '';

  const params = {
    "Username": emailAddress,
    "MessageAction": "RESEND", // This resends the invite without creating duplicate
    "UserAttributes": [
      {
        "Name": "email",
        "Value": emailAddress
      },
      { 
        "Name": "email_verified", 
        "Value": "true" 
      },
    ],
  }

  if (normalizedPhoneNumber?.length>0)  {
    params.UserAttributes.push({
      "Name": "phone_number",
      "Value": normalizedPhoneNumber,
    });
    params.UserAttributes.push({
      "Name": "phone_number_verified",
      "Value": "false",
    });
  }

  console.log('Resend invite params', params)
  
  try {
    const session = await fetchAuthSession();
    const authToken = `Bearer ${session.tokens.idToken}`;
    
    let inputJSON = JSON.stringify(params);
    
    const response = await fetch(endpointUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken,
      },
      body: inputJSON,
    });

    if (response.ok) {
      return response.json();
    } else {
      throw new Error(response.errorMessage || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Error resending invite:", error);
    return error.message || "Unknown error occurred";
  }
};

export const createCognitoUser = async (props) => {
  const {
    emailAddress,
    phoneNumber,
  } = props
  
  // function logLongString(str, chunkSize = 5000) {
  //   for (let i = 0; i < str.length; i += chunkSize) {
  //     console.log(str.substring(i, i + chunkSize));
  //   }
  // }

  const normalizedPhoneNumber = (phoneNumber?.length>0) ? normalizePhoneNumber(phoneNumber) : '';

  const params = {
    "Username": emailAddress,
    "UserAttributes": [
      {
        "Name": "email",
        "Value": emailAddress
      },
      { "Name": "email_verified", 
        "Value": "true" 
      },
      // {
      //   "Name": "email_verified",
      //   "Value": "true" // Pre-verified email
      // },
      // {
      //   "Name": "phone_number",
      //   "Value": phoneNumber // User's phone number, e.g., "+11234567890"
      // },
      // {
      //   "Name": "phone_number_verified",
      //   "Value": "true" // Set this to true if you verify the phone number externally or want it pre-verified
      // }
    ],
  }

  if (normalizedPhoneNumber?.length>0)  {
    params.UserAttributes.push({
      "Name": "phone_number",
      "Value": normalizedPhoneNumber,
    });
    params.UserAttributes.push({
      "Name": "phone_number_verified",
      "Value": "false",
    });
  }
  console.log('params', params)
  try {

    // Refresh the session to ensure it's current and to get the latest authentication tokens
    const session = await fetchAuthSession();
    const authToken = `Bearer ${session.tokens.idToken}`;
    
    // Prepare the request payload
    let inputJSON = JSON.stringify(params);
    
    // Fetch suggested addresses from your API
    const response = await fetch(endpointUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken,
      },
      body: inputJSON,
    });

    // console.info('<<<<< RESPONSE >>>>>', response);

    if (response.ok) {
      return response.json(); // This line reads the response stream and parses it as JSON.
    } else {
      throw new Error(response.errorMessage || "Unknown error occurred");
    }

    // const data = await response.json();
    // console.info('***** data: ', data); // Log the parsed data
    // console.info('***** data.body: ', data?.body); // Log the parsed data
    
    // // // Assuming data?.body contains the suggested addresses
    // return JSON.parse(data?.User);
  } catch (error) {
    console.error("Error creating user:", error);
    return error.message || "Unknown error occurred";
  }
};